import ApiHelper from './index'

const getShareableToken = async (params) => {
  return await ApiHelper.post(`result_sharing/generate_shareable_token`, params)
}
const verifyShareableAccess = async ({ token, password }) => {
  const headers = {
    'X-SHARE-TOKEN': token,
    'X-SHARE-PASSWORD': password
  }

  return await ApiHelper.get('result_sharing/verify_shareable_token', {}, null, headers)
}

export default {
  getShareableToken,
  verifyShareableAccess
}
